import React from 'react';
import './style.css';

import logo_1 from '../../assets/logos/Starlife Builders LOGO.png';
import logo_2 from '../../assets/logos/Starlife Capital Ventures LOGO.png';
import logo_3 from '../../assets/logos/Starlife Development LOGO.png';
import logo_4 from '../../assets/logos/Starlife International Realty LOGO.png';

export default function AffiliateCompanies() {
  return (
    <div className='affiliate-companies'>
      <h2 className='section-title'>Affiliate Companies</h2>
      <p>
        Starlife Group is powered by a network of specialized affiliates, each
        bringing expertise across development, construction, capital, and real
        estate services. Together, these companies ensure seamless execution
        from concept to completion on every project.
      </p>
      <div className='affiliate-logos'>
        <img src={logo_1} alt='Starlife Builders' />
        <img src={logo_2} alt='Starlife Capital Ventures' />
        <img src={logo_3} alt='Starlife Development' />
        <img
          src={logo_4}
          alt='Starlife International Realty'
          id='starlife-international-realty-logo'
        />
      </div>
    </div>
  );
}
